// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"eb2da739","630":"165eb1d3"}[chunkId] + ".chunk.css";
};